declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../../services/spinner.service';
import { AppData } from '../../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest } from '../../../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../services/hcp.service';


import * as alertFunctions from '../../../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, GuardianInfoRequest, SaveGuardianInfoRequest, SavePatientInfoRequest, CaseRegistrationByActorCodeController, CaseRegistrationByActorCodeRequest } from '../../../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../../../models/actor/actor';
import { ActorService } from '../../../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../../../models/master/mastermodel';
import { FDService } from '../../../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';

@Component({
  selector: 'ngbpartnerdetails',
  templateUrl: './partnerdetails.modal.html',
  styleUrls: ['./partnerdetails.modal.scss']
})

export class NgbPartnerDetails implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  @Input() IsShowDetail: boolean = false;
  @Input() CurrentActorEditGuardianInfoRequest: SaveGuardianInfoRequest;
  @Input() ServiceCode: number;
  @Input() ActorCode: number;
  searchTitle: string;
  DateOfBirth: NgbDateStruct;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  WeddingAn: NgbDateStruct;
  DateOfBirthFemale: NgbDateStruct;
  DateOfBirthMale: NgbDateStruct;
  public ApiResData: ApiResponseModel;
  public Date: Date;
  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  public Categories: boolean = true;
  //CurrentSavePatientInfoRequest: SavePatientInfoRequest;
  //CurrentActorEditGuardainInfoRequest: GuardianInfoRequest;
  //public IsSelected: boolean;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService, private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService) { }

  CurrentCaseRegistrationByActorCodeController: CaseRegistrationByActorCodeController[];
  PatientDetailsData: CaseRegistrationByActorCodeController;
  CurrentCaseRegistrationByActorCodeRequest: CaseRegistrationByActorCodeRequest;

  LoadCouple() {
    //alert("ScansData")
    this.CurrentCaseRegistrationByActorCodeRequest = new CaseRegistrationByActorCodeRequest();

    this.CurrentCaseRegistrationByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetCaseRegistrationByActorCodeController();
  }

  GetCaseRegistrationByActorCodeController() {
    this.StartRefreshing();

    this.CurrentCaseRegistrationByActorCodeRequest.ActorCode = this.ActorCode;
    //this.CurrentCaseRegistrationByActorCodeRequest.FromDate = new Date();
    //this.CurrentCaseRegistrationByActorCodeRequest.ToDate = new Date();
    this.CurrentCaseRegistrationByActorCodeRequest.Branch = AppData.Instance().SelectedBranchCode;
    this.CurrentCaseRegistrationByActorCodeRequest.ConditionalOperator = 10;
    this.actorservice.GetCaseRegistrationByActorCodeController(this.CurrentCaseRegistrationByActorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentCaseRegistrationByActorCodeController = this.ApiResData.Result;
          this.PatientDetailsData = this.CurrentCaseRegistrationByActorCodeController[0];
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  ngOnInit() {

    this.ShowService = false;

    this.LoadCouple();


  }





  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }





}
